import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { fdAdvantages } from "../fdModulesData";

const FdAdvantagesSection: React.FC = () => {
  return (
    <section className="wdev-process" aria-labelledby="fd-advantages-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="fd-advantages-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Platform Advantages
          </h2>
          <p className="fd-section-lead fd-section-lead--dark">
            A complete multi-vendor food ordering and delivery ecosystem built for customers,
            drivers, merchants, and administrators.
          </p>
        </AnimatedSection>

        <div className="fd-advantages-grid">
          {fdAdvantages.map((advantage, index) => (
            <motion.div
              key={advantage}
              className="wdev-process__card fd-advantage-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
            >
              <p className="fd-advantage-card__text">{advantage}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FdAdvantagesSection;
